import { lazy } from 'react';

const ReportsPage = lazy(() => import('../pages/Reports.page'));

const ReportsRoutes = [
    {
        path: '/reports',
        element: <ReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ReportsRoutes };
